
import hotels from './hotels'
import tours from './tours'
import fit from './fit'

import Components from '@/components'

const routes = [
  {
    path: '/search',
    redirect: { name: 'ToursSearch' },
    name: 'Search',
    component: Components.Services.Index,
    meta: { access: 'checkSearchAccess' },
    children: [
      ...hotels,
      ...tours,
      ...fit
    ]
  }
]

export default routes